<template>
  <v-container fluid class="investjournal-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-journal`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Journal
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab :href="`#tab-files`" class="mr-5">
            <v-icon class="mr-3">mdi-file-pdf-box</v-icon>
            Files
          </v-tab>
          <v-tab-item :value="'tab-journal'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Journal</p>
                      <v-select
                        :readonly="!isEditable"
                        class="mb-4"
                        :items="journaltype"
                        v-model="edit_journal.journaltype"
                        v-on:change="onChangeJournal($event, 'journaltype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the journal type"
                      >
                      </v-select>
                      <v-menu
                        ref="menu_journaldate"
                        v-model="menu_journaldate"
                        :close-on-content-click="false"
                        :return-value.sync="journaldate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="!isEditable"
                            class="mb-4"
                            outlined
                            dense
                            v-model="journaldate"
                            label="Journal Date"
                            v-bind="attrs"
                            v-bind:value="journaldate"
                            v-on:change="
                              onChangeJournal($event, 'journaldate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the journal date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="!isEditable"
                          v-model="journaldate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_journaldate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeJournal(
                                journaldate,
                                'journaldate'
                              );
                              $refs.menu_journaldate.save(journaldate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-menu
                        ref="menu_journalstartdate"
                        v-model="menu_journalstartdate"
                        :close-on-content-click="false"
                        :return-value.sync="journalstartdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="!isEditable"
                            class="mb-4"
                            outlined
                            dense
                            v-model="journalstartdate"
                            label="Start Date"
                            v-bind="attrs"
                            v-bind:value="journalstartdate"
                            v-on:change="
                              onChangeJournal($event, 'journalstartdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the start date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="!isEditable"
                          v-model="journalstartdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_journalstartdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeJournal(
                                journalstartdate,
                                'journalstartdate'
                              );
                              $refs.menu_journalstartdate.save(journalstartdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-menu
                        ref="menu_journalenddate"
                        v-model="menu_journalenddate"
                        :close-on-content-click="false"
                        :return-value.sync="journalenddate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="!isEditable"
                            class="mb-4"
                            outlined
                            dense
                            v-model="journalenddate"
                            label="Start Date"
                            v-bind="attrs"
                            v-bind:value="journalenddate"
                            v-on:change="
                              onChangeJournal($event, 'journalenddate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the start date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="!isEditable"
                          v-model="journalenddate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_journalenddate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeJournal(
                                journalenddate,
                                'journalenddate'
                              );
                              $refs.menu_journalenddate.save(journalenddate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="funds.map(x => {return {text: x.fundname, value: x._id}})"
                        v-model="edit_journal.fundid"
                        v-on:change="onChangeJournal($event, 'fundid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Investment Fund"
                        persistent-hint
                        single-line hint="Enter the investment fund">
                      </v-select>
                      <v-textarea
                          v-model="edit_journal.journalnote"
                          v-on:change="onChangeJournal($event, 'journalnote')"
                          outlined
                          dense
                          rows=1
                          label="Note"
                          hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Processing', 'Completed']"
                        v-model="edit_journal.journalstatus"
                        v-on:change="onChangeJournal($event, 'journalstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/investjournal/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateJournal()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/investjournal/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                        :headers="header_item"
                        :items="transactions"
                        :items-per-page="100"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.itemdesc }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.debit_accountid="{ item }">
                          <p class="two-line" v-if="item.debit_accountid!=null">{{ accounts.length>0 ? accounts.find(i=>i._id == item.debit_accountid)['accountname'] : '' }} (Receiving)</p>
                          <p class="two-line" v-if="item.credit_accountid!=null">{{ accounts.length>0 ? accounts.find(i=>i._id == item.credit_accountid)['accountname'] : '' }} (Deducting)</p>
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          <p class="two-line">{{ item.transtype }}</p>
                          <p class="two-line">{{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}</p>
                        </template>
                        <template v-slot:item.stockid="{ item }">
                          <div v-if="item.stockid!=null">{{ stocks.length>0 ? stocks.find(i=>i._id == item.stockid)['stockcode'] : '' }}</div>
                        </template>
                        <template v-slot:item.transamount="{ item }">
                          {{ item.transamount.toFixed(2) }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="editTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            v-if="isEditable"
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <FileEdit :id="initvalue._id" :data="initvalue.files" route="investjournal" />
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="transtypes"
                    v-model="new_transaction.transtype"
                    v-on:change="onChangeType($event, 'add')"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Select the type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="transdesc[ new_transaction.transtype ]"
                    v-model="new_transaction.transdesc"
                    v-bind:error="errorindex == 12"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Select the description">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu
                    ref="menu_transdate"
                    v-model="menu_transdate"
                    :close-on-content-click="false"
                    :return-value.sync="new_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-model="new_transaction.transdate"
                        label="Date"
                        v-bind="attrs"
                        v-bind:value="new_transaction.transdate"
                        v-bind:error="errorindex == 13"
                        v-on="on"
                        single-line hint="Transaction Date"
                        persistent-hint
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="new_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menu_transdate = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu_transdate.save(new_transaction.transdate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                   :disabled="new_transaction.transtype!=null ? !transconfig[new_transaction.transtype]['isPrc'] : true"
                    type="number"
                    v-model="new_transaction.transprice"
                    v-on:input="onChangeQuantity('add')"
                    v-bind:error="errorindex == 14"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Prc"
                    persistent-hint
                    single-line hint="Price">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :disabled="new_transaction.transtype!=null ? !transconfig[new_transaction.transtype]['isQty'] : true"
                    type="number"
                    v-model="new_transaction.transquantity"
                    v-on:input="onChangeQuantity('add')"
                    v-bind:error="errorindex == 15"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Qty"
                    persistent-hint
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.transamount"
                    v-bind:error="errorindex == 16"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <v-select
                    class="mb-4"
                    :items="stocks.map(x => {
                        return {text: x.stockcode, value: x._id};
                    })"
                    :disabled="new_transaction.transtype!=null ? !transconfig[new_transaction.transtype]['isStock'] : true"
                    v-model="new_transaction.stockid"
                    v-bind:error="errorindex == 17"
                    outlined
                    dense
                    placeholder="Stock"
                    persistent-hint
                    single-line hint="Stock">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    :readonly="true"
                    class="mb-4"
                    :items="accounts.map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.debit_accountid"
                    v-bind:error="errorindex == 18"
                    outlined
                    dense
                    placeholder="Receiving Account"
                    persistent-hint
                    single-line hint="Receiving Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    :readonly="true"
                    class="mb-4"
                    :items="accounts.map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.credit_accountid"
                    v-bind:error="errorindex == 19"
                    outlined
                    dense
                    placeholder="Deducting Account"
                    persistent-hint
                    single-line hint="Deducting Account">
                  </v-select>
                </v-col>

                
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}; errorindex=0"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="transtypes"
                    v-model="edit_transaction.transtype"
                    v-on:change="onChangeType($event, 'edit')"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Type"
                    persistent-hint
                    single-line hint="Select the type">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="transdesc[ edit_transaction.transtype ]"
                    v-model="edit_transaction.transdesc"
                    v-bind:error="errorindex == 12"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Select the description">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-menu
                    ref="menu_transdate_edit"
                    v-model="menu_transdate_edit"
                    :close-on-content-click="false"
                    :return-value.sync="edit_transaction.transdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-model="edit_transaction.transdate"
                        label="Date"
                        v-bind="attrs"
                        v-bind:value="edit_transaction.transdate"
                        v-bind:error="errorindex == 13"
                        v-on="on"
                        single-line hint="Transaction Date"
                        persistent-hint
                      >
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="edit_transaction.transdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menu_transdate_edit = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu_transdate_edit.save(edit_transaction.transdate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                   :disabled="edit_transaction.transtype!=null ? !transconfig[edit_transaction.transtype]['isPrc'] : true"
                    type="number"
                    v-model="edit_transaction.transprice"
                    v-on:input="onChangeQuantity('edit')"
                    v-bind:error="errorindex == 14"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Prc"
                    persistent-hint
                    single-line hint="Price">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    :disabled="edit_transaction.transtype!=null ? !transconfig[edit_transaction.transtype]['isQty'] : true"
                    type="number"
                    v-model="edit_transaction.transquantity"
                    v-on:input="onChangeQuantity('edit')"
                    v-bind:error="errorindex == 15"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Qty"
                    persistent-hint
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.transamount"
                    v-bind:error="errorindex == 16"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <v-select
                    class="mb-4"
                    :items="stocks.map(x => {
                        return {text: x.stockcode, value: x._id};
                    })"
                    v-model="edit_transaction.stockid"
                    v-bind:error="errorindex == 17"
                    outlined
                    dense
                    placeholder="Stock"
                    persistent-hint
                    single-line hint="Stock">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    :readonly="true"
                    class="mb-4"
                    :items="accounts.map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.debit_accountid"
                    v-bind:error="errorindex == 18"
                    outlined
                    dense
                    placeholder="Receiving Account"
                    persistent-hint
                    single-line hint="Receiving Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    :readonly="true"
                    class="mb-4"
                    :items="accounts.map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.credit_accountid"
                    v-bind:error="errorindex == 19"
                    outlined
                    dense
                    placeholder="Deducting Account"
                    persistent-hint
                    single-line hint="Deducting Account">
                  </v-select>
                </v-col>

                
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}; errorindex=0"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { sortDataAsc } from '../../../util/tools';
import { formatStdDate } from '@/mixins/date';
import FileEdit from "../../File/Components/FileEdit.vue";
import router from "@/Routes";

export default {
  data() {
    return {
      header_item: [
        { text: 'Type & Date', value: 'transdate', width: '10%'},
        { text: 'Account', value: 'debit_accountid', width: '30%'},
        { text: 'Description', value: 'transdesc'},
        { text: 'Stock', value: 'stockid', width: '8%'},
        { text: 'Prc', value: 'transprice', width: '8%'},
        { text: 'Qty', value: 'transquantity', width: '8%'},
        { text: 'Amt', value: 'transamount', width: '8%'},
        { text: "Actions", value: "actions", sortable: false, width: '10%' },
      ],

      initvalue: {},
      change_journal: {},
      edit_journal: {},
      edit_transaction: {},
      new_transaction: {},
      delete_transaction: {},

      files: [],
      transactions: [],
      journaltype: ['Investment Journal', 'Monthly Statement'],
      transtypes: ['Deposit', 'Withdrawl', 'Purchase', 'Sale', 'Dividend', 'Interest', 'Margin', 'Transfer In', 'Transfer Out'],
      transdesc: {
        'Deposit': ['Transfer from Bank'],
        'Withdrawl': ['Transfer to Bank'],
        'Purchase': ['Buy Stock'],
        'Sale': ['Sell Stock'],
        'Dividend': ['Qualified Dividend', 'Non-Qualified Dividend', 'Cash Dividend'],
        'Interest': ['Bank Interest'],
        'Margin': ['Margin Interest'],
        'Transfer In': ['Transfer In Stock'],
        'Transfer Out': ['Transfer Out Stock'],
      },
      transconfig: {
        'Deposit': {isStock: false, isQty: false, isPrc: false},
        'Withdrawl': {isStock: false, isQty: false, isPrc: false},
        'Purchase': {isStock: true, isQty: true, isPrc: true},
        'Sale': {isStock: true, isQty: true, isPrc: true},
        'Dividend': {isStock: true, isQty: false, isPrc: false},
        'Interest': {isStock: false, isQty: false, isPrc: false},
        'Margin': {isStock: false, isQty: false, isPrc: false},
        'Transfer In': {isStock: true, isQty: true, isPrc: true},
        'Transfer Out': {isStock: true, isQty: true, isPrc: true},
      },
      footer: {'items-per-page-options': [500, 1000, 5000]},      
      
      journaldate: null,
      journalstartdate: null,
      journalenddate: null,
      menu_journaldate: false,
      menu_journalstartdate: false,
      menu_journalenddate: false,
      menu_transdate: false,
      menu_transdate_edit: false,

      isAddTransaction: false,
      isEditTransaction: false,
      isDeleteTransaction: false,  
      error: null,  
      errorindex: null,
    };
  },
  components: {
    FileEdit,
  },
  computed: {
    ...mapState("Account", ["accounts"]),
    ...mapState("InvestJournal", ["isReceiving"]),
    ...mapState("InvestFund", ["funds"]),  
    ...mapState("InvestStock", ["stocks"]),  
    isEditable(){
      let result = ['New','Processing'].indexOf(this.initvalue.journalstatus) >= 0;
      return result;
    },
  },
  methods: {
    ...mapActions("Account", ["getAccountsRequest"]),
    ...mapActions("InvestJournal", ["deleteJournalTransactionRequest", "getInvestJournalRequest", "insertJournalTransactionRequest", "updateInvestJournalRequest", "updateJournalTransactionRequest"]),
    ...mapActions("InvestFund", ["getInvestFundsRequest"]),
    ...mapActions("InvestStock", ["getInvestStocksRequest"]),
    checkJournal() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(transaction){
      if(!transaction.transtype){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!transaction.transdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!transaction.transdate){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      if(this.transconfig[transaction.transtype].isPrc==true &&  !transaction.transprice){
        this.haserrors = true;
        this.errorindex = 14;
        return false;
      }
      if(this.transconfig[transaction.transtype].isPrc==true &&  !transaction.transquantity){
        this.haserrors = true;
        this.errorindex = 15;
        return false;
      }
      if(!transaction.transamount){
        this.haserrors = true;
        this.errorindex = 16;
        return false;
      }
      if(this.transconfig[transaction.transtype].isStock==true &&  !transaction.stockid){
        this.haserrors = true;
        this.errorindex = 17;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    calculateAmount() {
      if(this.route==0)this.new_transaction.itemamount = this.new_transaction.itemquantity * this.new_transaction.itemprice;
      else if(this.route==1)this.edit_transaction.itemamount = this.edit_transaction.itemquantity * this.edit_transaction.itemprice;
      this.itemamount = this.edit_transaction.itemamount;  
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    clearStockFields(route){
      console.log(route)
      if(route=='edit') this.edit_transaction = Object.assign(this.edit_transaction, {stockid: null, transprice: null, transquantity: null});
      else this.new_transaction = Object.assign(this.new_transaction, {stockid: null, transprice: null, transquantity: null});
      console.log(this.new_transaction)
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemdesc: item.itemdesc};
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteJournalTransactionRequest(payload);
      let index = this.transactions.findIndex((i) => i._id == response._id);
      this.transactions.splice(index, 1);
      this.getInvestJournalRequest(this.initvalue._id);
    },
    async insertTransaction() {
      if(!this.checkTransaction(this.new_transaction)) return;
      this.isAddTransaction = false;
      let payload = Object.assign({id: this.initvalue._id}, this.new_transaction);
      let response = await this.insertJournalTransactionRequest(payload);
      this.transactions.push(response);
      this.getInvestJournalRequest(this.initvalue._id);
      this.clearTransaction();
    },
    editTransactionDialog(item) {
      this.edit_transaction = Object.assign({}, item);
      this.edit_transaction.transdate = formatStdDate(this.edit_transaction.transdate);
      this.isEditTransaction = true;
    },
    async editTransaction() {
      this.isEditTransaction = false;
      let response = await this.updateJournalTransactionRequest(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.clearTransaction();
      this.getInvestJournalRequest(this.initvalue._id);
    },
    onChangeJournal(value, field) {
      this.change_journal[field] = value;
    },
    onChangeType(type, route){
      this.getAccount(type, route);
    },
    onChangeQuantity(route){
      let update = {};
      
      if(route=='edit') {
        if(!this.edit_transaction.transquantity && !this.edit_transaction.transquantity) return;
        update.transamount =  this.edit_transaction.transquantity * this.edit_transaction.transprice;
        this.edit_transaction = Object.assign(this.edit_transaction, update);
      }
      else {
        if(!this.new_transaction.transquantity && !this.new_transaction.transquantity) return;
        update.transamount =  this.new_transaction.transquantity * this.new_transaction.transprice;
        this.new_transaction = Object.assign(this.new_transaction, update);
      }
    },
    getAccount(type, route){
      let result = {};
      let fund = this.funds.find(i=>i._id==this.initvalue.fundid);
      if(type=='Deposit'){
        result.debit_accountid = fund.cash_accountid;
        result.credit_accountid = fund.bank_accountid;
        this.clearStockFields(route);
      }
      if(type=='Withdrawl'){
        result.debit_accountid = fund.bank_accountid;
        result.credit_accountid = fund.cash_accountid;
        this.clearStockFields(route);
      }
      if(type=='Purchase'){
        result.debit_accountid = fund.asset_accountid;
        result.credit_accountid = fund.cash_accountid;
      }
      if(type=='Sale'){
        result.debit_accountid = fund.cash_accountid;
        result.credit_accountid = fund.asset_accountid;
      }
      if(type=='Dividend'){
        result.debit_accountid = fund.cash_accountid;
        result.credit_accountid = fund.dividend_accountid;
      }
      if(type=='Interest'){
        result.debit_accountid = fund.cash_accountid;
        result.credit_accountid = fund.interest_accountid;
        this.clearStockFields(route);
      }
      if(type=='Margin'){
        result.debit_accountid = fund.expense_accountid;
        result.credit_accountid = fund.cash_accountid;
      }
      if(type=='Transfer In'){
        result.debit_accountid = fund.asset_accountid;
        result.credit_accountid = null
      }
      if(type=='Transfer Out'){
        result.credit_accountid = fund.asset_accountid;
        result.debit_accountid = null
      }
      if(route=='edit' )this.edit_transaction = Object.assign(this.edit_transaction, result);
      else this.add_transaction = Object.assign(this.new_transaction, result);
    },

  
    async updateJournal() {
      this.change_journal._id = this.initvalue._id;
      await this.updateInvestJournalRequest(this.change_journal);
      router.push("/investjournal/list");
    },

  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "InvestJournalList" });
    this.edit_journal = Object.assign({}, this.initvalue);
    this.journaldate = formatStdDate(this.initvalue.journaldate);
    this.journalstartdate = formatStdDate(this.initvalue.journalstartdate);
    this.journalenddate = formatStdDate(this.initvalue.journalenddate);

    if (this.accounts.length==0) await this.getAccountsRequest();
    if (this.funds.length==0) await this.getInvestFundsRequest();
    if (this.stocks.length==0) await this.getInvestStocksRequest();
    sortDataAsc(this.funds, 'fundrank');
    sortDataAsc(this.stocks, 'stockcode');

    this.files = this.initvalue.files;
    this.transactions = Object.assign([], this.initvalue.transactions);
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
